module.exports = __webpack_public_path__ + "img/pan_left.019cb48c.svg";